import * as wheelUpDirective from './wheel-up.directive';

export default angular.module('gazelle.components.mouse.wheelUp', [
])
  .directive(wheelUpDirective.name, wheelUpDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/mouse-wheel/wheel-up/wheel-up.module.js